const cdnUrl = 'https://fuel-ds.fretebras.com.br';

export { cdnUrl as c };

//# sourceMappingURL=constants-36b60b05.js.map